"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withContexts = exports.createCtx = void 0;
var tslib_1 = require("tslib");
var createCtx = function (defaultVal) {
    var _value;
    var provide = function (val) {
        _value = val;
    };
    if (defaultVal !== undefined) {
        provide(defaultVal);
    }
    var _getValue = function () { return _value; };
    var getValue = function () {
        if (_value === undefined) {
            var err = new Error('reading not provided context');
            console.error(err);
            throw err;
        }
        return _value;
    };
    return { provide: provide, getValue: getValue, _getValue: _getValue };
};
exports.createCtx = createCtx;
var withContexts = function (values, fn) {
    return (function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var cleanups = values.map(function (_a) {
            var ctx = _a.ctx, val = _a.val;
            var prevValue = ctx._getValue();
            ctx.provide(val);
            return function () {
                ctx.provide(prevValue);
            };
        });
        var res = fn.apply(void 0, (0, tslib_1.__spreadArray)([], (0, tslib_1.__read)(args), false));
        cleanups.forEach(function (clean) { return clean(); });
        return res;
    });
};
exports.withContexts = withContexts;
//# sourceMappingURL=context.js.map